export const verificarSePossuiPermissaoDeAcessoDoUsuario = (permissaoDeAcesso: string) => {
  const permissoes = localStorage.getItem('permissoesDeAcessoDoUsuario');
  if (permissoes == null)
    return false;

  return permissoes.includes(permissaoDeAcesso);
};
  
